import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useToast } from '@/components/Toast';
import { BrandMarkLarge } from '@/components/Logo';
import { I } from '@/lib/icons';

export default function Login() {
  const { session, loading, signInWithEmail } = useAuth();
  const toast = useToast();
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  if (loading) return null;
  if (session) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (!email || sending) return;
    setSending(true);
    try {
      await signInWithEmail(email.trim());
      setSent(true);
      toast.success('Magic link odoslaný — skontroluj email.');
    } catch (err) {
      toast.error(err.message || 'Nepodarilo sa odoslať magic link.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24,
    }}>
      <div style={{
        width: '100%', maxWidth: 420,
        background: 'var(--bg-surface)', border: '1px solid var(--border)',
        borderRadius: 'var(--r-2xl)', padding: '40px 36px',
        boxShadow: 'var(--sh-md)',
        animation: 'cd-modalIn 0.4s var(--ease)',
      }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
          <BrandMarkLarge size={72} />
        </div>
        <h1 style={{
          margin: 0, fontSize: 28, fontWeight: 700, textAlign: 'center',
          fontFamily: 'var(--font-display)', letterSpacing: '-0.025em',
        }}>podnikai.sk</h1>
        <p style={{
          margin: '6px 0 28px', fontSize: 13, color: 'var(--text-muted)',
          textAlign: 'center', lineHeight: 1.55,
        }}>
          Fakturácia pre slovenských živnostníkov a s.r.o. —<br />
          jednoducho, bez mesačných poplatkov.
        </p>

        {sent ? (
          <div style={{
            background: 'var(--success-dim)', border: '1px solid var(--success)',
            borderRadius: 'var(--r-md)', padding: '16px 18px',
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, textAlign: 'center',
          }}>
            <span style={{
              width: 36, height: 36, borderRadius: '50%', background: 'var(--success)',
              color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <I.mail />
            </span>
            <div style={{ fontWeight: 600, color: 'var(--success)' }}>Skontroluj email</div>
            <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>
              Poslali sme magic link na <strong>{email}</strong>.<br />
              Klikni na odkaz a budeš prihlásený/á.
            </div>
            <button type="button" onClick={() => { setSent(false); setEmail(''); }}
              className="cd-btn cd-btn-ghost cd-btn-sm" style={{ marginTop: 4 }}>
              Poslať znova
            </button>
          </div>
        ) : (
          <form onSubmit={submit}>
            <label style={{
              display: 'block', fontSize: 11, fontWeight: 700, color: 'var(--text-muted)',
              textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 6,
            }}>Email</label>
            <input data-testid="login-email" type="email" required autoFocus
              value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="tvoj@email.sk"
              className="cd-input"
              style={{ marginBottom: 14, padding: '12px 14px', fontSize: 14 }}
            />
            <button data-testid="login-submit" type="submit" disabled={sending || !email}
              className="cd-btn cd-btn-primary"
              style={{ width: '100%', padding: '12px 18px', fontSize: 14, justifyContent: 'center' }}
            >
              {sending ? <><span className="cd-spinner" style={{ borderTopColor: '#fff' }} /> Posílam...</>
                : <><I.mail /> Poslať magic link</>}
            </button>
            <div style={{
              marginTop: 18, fontSize: 11.5, color: 'var(--text-muted)',
              textAlign: 'center', lineHeight: 1.5,
            }}>
              Nepotrebuješ heslo. Po kliknutí v emaili budeš prihlásený/á.
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
